module.exports = __webpack_public_path__ + "media/src/img/logo-bg-679abf0f64767616db1255c8d89e9b98.svg";